

import React,{ Fragment } from "react";
import { MdClose } from "react-icons/md";

export const addNotification = (props, message, variant = "info") => {
    const action = (key) => (
        <Fragment>
          <button
            className='btn btn-light btn-sm rounded-circle'
            onClick={() => {
              props.closeSnackbar(key);
            }}
          >
            <MdClose />
          </button>
        </Fragment>
      );
    const options = {variant, anchorOrigin: { vertical: "bottom", horizontal: "center", autoHideDuration: 1000 },action };
    return props.enqueueSnackbar(message, options)
}

export const returnDate = (type) =>{
    if(type = "CDATE"){
        return new Date()
    }
}